import React, { useState } from "react";
import "../../../Styles.css";
import "../../../../../ui-styles/inlineLink/inlineLinkIcon.css";
import "../../../../../ui-styles/list/contactListAction.css";
import DeleteConfirmModal from "../DeleteConfirmModal";
import { useHistory } from 'react-router-dom';
import { DisableEnable, deleteUser } from "../../../../../actions/users";
// import Button from "../../../../../lib/ui/buttons/Button";
import VerifyPopup from "../VerifyPopup";
import { Link } from "react-router-dom";
import Loading from "../../../../../components/loading";
import { toast } from "react-toastify";
import DisableEnableUser from "../DisableUser";
import { MdLockReset } from "react-icons/md";
import { Divider } from "@material-ui/core";
import ResetPwdPopup from "../../../../common/ResetPwdPopup";
import { resetpassword } from "../../../../../actions/users";

const PatientListItems = (props) => {
    const history = useHistory();
    const { data, role, l } = props;
    const [openDelete, setOpenDelete] = useState(false)
    const [openPopup, setopenPopup] = useState(false)
    const [loading, setLoading] = useState(false);
    const [active,setActive] =useState(false);
    const [pswdPopup, setPswdPopup] = useState(false);

    const handleOpenPswd = () => {
        setPswdPopup(true);
    };
  
    const handleClosePswd = () => {
        setPswdPopup(false);
    };
    // const [verify, setVerify] = useState(data.verify);

    const handleVerify = () => {
        // setVerify(prevState => !prevState);
        setopenPopup(prevState => !prevState);
    }

    const handlePopup = () => {
        setopenPopup(prevState => !prevState);
    }

    const handleOpen = () => {
        setOpenDelete(prevState => !prevState);
    }

    const handleDelete = () => {
        setLoading(true);
        deleteUser({ username: props.data.userId, consultRole: 'patient' }).then(res => {
            setLoading(false);
            if (res && res.status) {
                props.reloadData();
                toast.success(l.pat_del, {
                    position: toast.POSITION.TOP_RIGHT
                })
            }
        }).catch(err => {
            toast.error(err?.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            })
            setLoading(false);
            console.log("err ==== ", err);
        })
    }

    const disableEnable=async()=>{
        setLoading(true);
        const isActive =  data.hasOwnProperty('isActive') ? !data.isActive : false;
        DisableEnable({ userId: props.data.userId,isActive }).then(res => {
            setLoading(false);
            if (res && res.status) {
                setActive(!active)
                props.reloadData();
                toast.success(res.data, {
                    position: toast.POSITION.TOP_RIGHT
                })
            }
        }).catch(err => {
            toast.error(err?.response?.data?.error, {
                position: toast.POSITION.TOP_RIGHT
            })
            setLoading(false);
            console.log("err ==== ", err);
        })
    }

    return (
        <>
            <li className="cntcListItem Md alignStart" key={data.userId}>
                {loading && <Loading />}
                <div className="cntcListAvtr Md">
                    {data.profilePic ?
                        <img src={data.profilePic} alt="avatar" />
                        :
                        <div className="roundimg">{data.firstName.charAt(0)}</div>
                    }
                </div>
                <div className="cntcListContent" onClick={() => props.handleSlide(data)}>
                    <span className="elslistTxtL">{data.firstName ? data.firstName : ''}{data.lastName ? ` ${data.lastName}` : ''}</span>
                    <div className="rowBlock alignCenter">
                        <span className="elslistTxtM">{data?.email && data.email} {data.countryCode ? `+${data.countryCode} `:''}{data.phone ? data.phone?.replaceAll('+91','') : '--'}</span>

                        {/*verify && verify === true ?
                            <div className="actionItem noHover" tooltip="Verified">
                                <img src="/images/icons/verified.png" alt="icon" />
                            </div>
                            :
                            <div className="mrgLeft8">
                                <Button
                                    label={l.vfy}
                                    type='outLine'
                                    size='xs'

                                onClick={(e) => { e.stopPropagation(); handlePopup(); }}
                            />
                        </div>*/}
                    </div>
                    <span className="elslistTxtM">{data.gender ? l[data.gender] : ''}</span>
                    {(role === "CA" || role === "SA") && <span className="elslistTxtM">{data.subdomain ? data.subdomain : '--'}</span>}

                    <div className="showInRes mrgTop8">
                        <Link className="inlineLink Sm" to={`/doctor-schedule/${data.userId}`}><span>{l.book_apptmnt}</span></Link>
                    </div>

                </div>
                <div className="cntcListAction" >
                    {role === "C" && <div className="showInWeb" style={{marginRight:'8px'}}>
                        <Link className="inlineLink Sm" to={`/doctor-schedule/${data.userId}`}><span>{l.book_apptmnt}</span></Link>
                    </div>}
                    <Divider orientation="vertical" flexItem style={{alignSelf:'center', height:'30px' }}/>
                    <div
                    onClick={handleOpenPswd}
                     className="actionPswd" tooltip="Reset Password">
                     <MdLockReset style={{fontSize:'24px',color:'#23A4C4'}}/>
                    </div>
                    <Divider orientation="vertical" flexItem style={{alignSelf:'center', height:'30px' }}/>
                    {data.isActive === false ?
                    <div className="actionItem" tooltip='Disable' onClick={()=>setActive(!active)} >
                        <img src="/images/icons/Block.png" alt="icon" />
                    </div>:
                    <div className="actionItem" tooltip='Enable' onClick={()=>setActive(!active)} >
                        <img src="/images/icons/Patient.png" alt="icon" className="invertPrimary" />
                    </div>
                    }
                    <div className="actionItem" tooltip='Edit' onClick={() => { (role === "CA" || role === "SA") ? history.push(`/admin-createusers?pId=${data.userId}`) : history.push(`/clinic-createusers?pId=${data.userId}`) }} >
                        <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                    </div>
                    <div className="actionItem" tooltip="Delete" onClick={handleOpen}>
                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                    </div>

                </div>
                {active &&
                    <DisableEnableUser handleDelete={disableEnable} openDelete={active} closeDelete={()=>setActive(!active)} header={data.isActive === false?"Enable":"Disable"} />}
                {openDelete &&
                    <DeleteConfirmModal handleDelete={handleDelete} openDelete={openDelete} closeDelete={handleOpen} data={data} header={l.patient} />}
                {openPopup &&
                    <VerifyPopup openVerify={openPopup} closePopup={handlePopup} handleVerify={handleVerify} phone={data.phone} />}
               {pswdPopup && (
                        <ResetPwdPopup
                            open={pswdPopup}
                            onClose={handleClosePswd}
                            userData={data} 
                            resetPassword={resetpassword}
                        />
                    )}
            </li>
        </>
    )
}
export default PatientListItems;